exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pr-chart {\n  width: 100%;\n  text-align: center;\n}\n\ncanvas {\n  margin: 0 auto;\n}\n\n.pr-chart-header {\n  font-family: \"Google Sans Regular\";\n}\n\n@media (max-width: 768px) {\n  .pr-chart-header {\n    font-size: 20px;\n  }\n}\n", ""]);

